<mat-toolbar class="primary">
    <span class="adx-contact-group-icon"><i class="fa-solid fa-folder-open"></i></span>
    {{'ASTIMAX.CONTACT.WIDGET.DELETE_CONTACT_GROUP' | translate }}
    <span class="adx-toolbar-spacer"></span>
    <button mat-icon-button
            [mat-dialog-close]="true"
            aria-label="Dialog schließen"
            matTooltip="{{'ASTIMAX.CONTACT.WIDGET.CLOSE' | translate }}">
        <fa-icon [icon]="'xmark'"></fa-icon>
    </button>
</mat-toolbar>

<mat-dialog-content class="adx-dialog-content-wrapper">
    <p class="adx-delete-contact-group-context">
        {{'ASTIMAX.CONTACT.WIDGET.HELP_TEXT_DELETE_CONTACTS_START' | translate }}
        <strong>{{ data.name }}</strong>
        {{'ASTIMAX.CONTACT.WIDGET.HELP_TEXT_DELETE_CONTACTS_END' | translate }}?
    </p>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
    <button mat-raised-button
            [mat-dialog-close]="true"
            type="button"
            aria-label="Bearbeitung abbrechen"
            matTooltip="{{'ASTIMAX.CONTACT.WIDGET.CANCEL_EDITING' | translate }}">
        {{'ASTIMAX.CONTACT.WIDGET.CANCEL' | translate }}
    </button>
    <button mat-raised-button
            class="primary"
            (click)="confirm()"
            type="button"
            [attr.aria-label]="'Kontaktgruppe löschen'"
            matTooltip="  {{'ASTIMAX.CONTACT.WIDGET.DELETION_CONFIRM' | translate }}">
        {{'ASTIMAX.CONTACT.WIDGET.CONFIRM' | translate }}
    </button>
</mat-dialog-actions>
